const About = () => {
  return (
    <section
      id="about"
      data-testid="section-about"
      className="bg-[#F7F7F4]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-24 md:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
          <div className="lg:col-span-5">
            <div className="overline">— About</div>
            <h2 className="mt-5 font-sora text-[36px] sm:text-[44px] lg:text-[54px] font-bold text-[#111111] tracking-tight leading-[1.05]">
              Built for people who want simple systems.
            </h2>
          </div>

          <div className="lg:col-span-7 lg:pt-2">
            <div className="space-y-6 font-manrope text-[17px] md:text-[18px] leading-[1.75] text-[#111111]/75 max-w-2xl">
              <p>
                Vaymilo is a digital product studio focused on clear, practical
                tools. Every kit is designed to be easy to use, useful from day
                one, and simple enough to fit into your existing workflow.
              </p>
              <p>
                We don&apos;t promise to change your life. We make small,
                considered things that help you write a better email, plan a
                cleaner week, or finish the work already on your desk.
              </p>
            </div>

            <div className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-px bg-[#E7E7E2] border border-[#E7E7E2] rounded-xl overflow-hidden">
              {[
                { k: "Studio", v: "Independent · Remote" },
                { k: "Focus", v: "Practical, calm tools" },
                { k: "Tone", v: "Honest. Not hype." },
              ].map((m) => (
                <div key={m.k} className="bg-white px-6 py-5">
                  <div className="font-mono text-[10px] tracking-[0.2em] uppercase text-[#111111]/45">
                    {m.k}
                  </div>
                  <div className="mt-1 font-manrope text-[15px] text-[#111111]">
                    {m.v}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
